import Link from 'next/link';
import React from 'react';

interface IProps {
  link: string;
  text: string;
  className?: string;
  includeArrow?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export const Button: React.FC<IProps> = ({ link, text, includeArrow = true, className, onClick }) => (
  <Link href={link} className={className} onClick={onClick}>
    <div className='bg-red-600 hover:bg-red-700 flex w-max flex-row items-center rounded-md px-4 py-2 font-semibold text-white transition-colors duration-100'>
      <span>{text}</span>
      {includeArrow ? <i className='fa fa-chevron-right ml-3 text-sm' /> : null}
    </div>
  </Link>
);

interface IUnderlineButtonProps {
  link: string;
  text: string;
  className?: string;
  underlineWidth?: string;
}

const UnderlineContent: React.FC<{ text: string; underlineWidth: string }> = ({ text, underlineWidth }) => (
  <div className='relative inline-flex h-6 w-full flex-col items-center justify-center gap-1'>
    <div className='flex w-fit flex-col items-start justify-center gap-0.5'>
      <div className='flex w-full flex-row items-center justify-center gap-1'>
        <div className='text-pink-950 justify-start text-center text-sm font-medium leading-none'>{text}</div>
        <div className='relative flex size-4 items-center justify-center'>
          <i className='fa fa-arrow-right text-red-950 text-xs' />
        </div>
      </div>
      <svg xmlns='http://www.w3.org/2000/svg' width={underlineWidth} height='3' viewBox='0 0 47 3' fill='none'>
        <path
          d='M1.38672 2C7.8121 2 14.2304 1.17853 20.6552 1.05229C25.6912 0.95334 30.7285 1.02521 35.7648 1.02521C38.0423 1.02521 42.736 1.02521 45.0127 1.02521'
          stroke='#5E233B'
          stroke-width='2'
          stroke-linecap='square'
        />
      </svg>
    </div>
  </div>
);

export const UnderlineButton: React.FC<IUnderlineButtonProps> = ({ link, text, className, underlineWidth = '50' }) => (
  <Link href={link} className={className}>
    <UnderlineContent text={text} underlineWidth={underlineWidth} />
  </Link>
);

/** {@link UnderlineButton}'s look without its link, for use inside an element that is already a link. */
export const UnderlineLabel: React.FC<Omit<IUnderlineButtonProps, 'link'>> = ({
  text,
  className,
  underlineWidth = '50',
}) => (
  <div className={className}>
    <UnderlineContent text={text} underlineWidth={underlineWidth} />
  </div>
);
